import $ from 'jquery';

export default class MainHeader {

    init() {
        this.$element = $('#app-main-header');

        // @TODO add scopfe if this elements only in header
        $('.js-nav-button').on('click', this.openMenu.bind(this));
        $('.js-nav-user').on('click', this.openDropdownMenu.bind(this));
        this.moreElement();
        window.onresize = () => {this.moreElement()};
        // @TODO move to methods open/close
        window.onclick = function (e) {
            if (!e.target.matches('.js-nav-user')) {
                if ($('.js-user-dropdownmenu').hasClass('open')) {
                    $('.js-user-dropdownmenu').removeClass('open');
                    $('.js-nav-menu').removeClass('openUserMenu');
                }
            }
        };
        return this;
    }

    moreElement() {
        if ($(window).width() >= 992) {
            if ($('.js-nav-menu').find('.header__nav-menu').height() > 65 ){
                $('.js-nav-menu').addClass('more');

                let list_item = $('.js-nav-menu').find('.header__nav-menu li a');
                let readmore_link = "";

                $( list_item ).each(function( index ) {
                    if($(this).position().top > 0){
                        readmore_link += $(this).get(0).outerHTML;
                    }
                });

                $('.js-nav-menu-more').html(readmore_link);
            } else {
                $('.js-nav-menu').removeClass('more');
            }
        }
    }

    openMenu() {
        $('body.moydom').addClass('open');
        $('.js-nav-menu').addClass('open');
        $('.js-destroy-mask').click(this.destroyMenu.bind(this));
        $('.js-nav-menu-close').click(this.destroyMenu.bind(this));
    }

    destroyMenu() {
        $('body.moydom').removeClass('open');
        $('.js-nav-menu').removeClass('open');
        $('.js-destroy-mask').unbind('click');
        $('.js-nav-menu-close').unbind('click');
    }

    openDropdownMenu() {
        if ($('.js-user-dropdownmenu').hasClass('open')) {
            $('.js-user-dropdownmenu').removeClass('open');
            $('.js-nav-menu').removeClass('openUserMenu');
        } else {
            $('.js-user-dropdownmenu').addClass('open');
            $('.js-nav-menu').addClass('openUserMenu');
        }
    }
}
